import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqs = [{
  question: "Welche Nutzungsrechte habe ich als Mitglied?",
  answer: "Als Mitglied haben Sie vollen Zugang zu den gebuchten Arbeitsplätzen, unseren ergonomischen Gemeinschaftsbereichen und Highspeed-Internet. Je nach Tarif inkludiert dies auch die Nutzung von Telefonkabinen und ein Kontingent für Besprechungsräume."
}, {
  question: "Darf ich Gäste in den Coworking Space mitbringen?",
  answer: "Ja, Gäste sind für kurze Abstimmungen oder informelle Treffen in unseren Loungebereichen herzlich willkommen. Für längere Arbeitssitzungen oder die Nutzung eines festen Arbeitsplatzes bitten wir um die Buchung einer Tageskarte für Ihren Gast."
}, {
  question: "Wie sind die Kündigungsfristen für die verschiedenen Tarife?",
  answer: "Wir setzen auf Flexibilität. Unsere monatlichen Mitgliedschaften können in der Regel mit einer Frist von 30 Tagen zum Monatsende gekündigt werden. Langfristige Fix-Desk-Verträge haben individuelle Laufzeiten, die transparent in Ihrem Vertrag geregelt sind."
}, {
  question: "Gibt es eine Hausordnung für die Gemeinschaftsküche?",
  answer: "Für ein harmonisches Miteinander bitten wir alle Nutzer, die Küche sauber zu hinterlassen. Benutztes Geschirr gehört direkt in die Spülmaschine, und Lebensmittel im Kühlschrank sollten mit Namen und Datum versehen werden."
}, {
  question: "Wie wird der Datenschutz und die Privatsphäre gewährleistet?",
  answer: "Ihre Daten werden streng nach DSGVO-Richtlinien behandelt. In unseren Räumlichkeiten bieten wir zudem schallisolierte Telefonkabinen und Sichtschutzoptionen an, damit Sie jederzeit vertraulich arbeiten und telefonieren können."
}, {
  question: "Ist mein Equipment über den Coworking Space versichert?",
  answer: "Unsere Betriebshaftpflicht deckt Schäden am Gebäude und Inventar ab. Für Ihr persönliches Equipment (Laptops, Kameras, etc.) empfehlen wir den Abschluss einer eigenen Elektronik- oder Inhaltsversicherung, da diese nicht über uns mitversichert sind."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="15172" id="user-rights" className="bg-background text-foreground py-24 relative overflow-hidden">
      <div ref={ref} className={cn("container mx-auto px-6 transition-all duration-700 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <div className="max-w-[800px] mx-auto">
          <div className="text-left mb-12">
            <h2 className="text-3xl md:text-4xl font-default font-semibold text-foreground mb-4">
              Ihre Rechte & Hausordnung
            </h2>
            <p className="text-muted-foreground text-lg max-w-2xl">
              Wichtige Informationen zu Ihrer Mitgliedschaft, den Nutzungsbedingungen und unseren Gemeinschaftsrichtlinien für ein produktives Miteinander.
            </p>
          </div>

          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b border-border/60 last:border-0 px-2 transition-all duration-300 data-[state=open]:bg-card data-[state=open]:shadow-lg data-[state=open]:rounded-xl" data-index={i}>
                <AccordionTrigger className="text-xl font-semibold font-default text-foreground hover:text-primary hover:no-underline py-5 text-left transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}